import actions from './actions';

let initState = {
    younoteAdminDashboardLoader: false,
    younoteAdminDashboardDetails: '',
    younoteAdminDashboardError: ''
};

export default function younoteAdminDashboardReducer(state = initState, action) {
    switch (action.type) {
        case actions.YOUNOTE_ADMIN_DASHBOARD_START: {
            return {
                ...state,
                younoteAdminDashboardLoader: true
            };
        }
        case actions.YOUNOTE_ADMIN_DASHBOARD_SUCCESS: {
            return {
                ...state,
                younoteAdminDashboardLoader: false,
                younoteAdminDashboardDetails: action.payload
            };
        }
        case actions.YOUNOTE_ADMIN_DASHBOARD_FAILURE: {
            return {
                ...state,
                younoteAdminDashboardLoader: false,
                younoteAdminDashboardDetails: action.payload
            };
        }
        default:
            return state;
    }
}

